import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { User } from '../../entities/User';
import { Pagination } from '../../features/Pagination/index.js';
import { useUrlPagination } from '../../shared/hooks/useUrlPagination.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EmptyState } from '../../shared/ui/EmptyState';
import { UserPlus, UsersRound } from 'lucide-react';

const UsersPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { page, offset, pageSize, setPage } = useUrlPagination(10);
  // Применённый поиск — в URL, в поле — черновик
  const query = searchParams.get('q') || '';
  const [users, setUsers] = useState(null);
  const [searchValue, setSearchValue] = useState(query);
  const [count, setCount] = useState(0);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => setSearchValue(query), [query]);

  useEffect(() => {
    let cancelled = false;
    apiRequests.users.getFiltered(query, pageSize, offset).then((res) => {
      if (cancelled) return;
      setUsers(res.items);
      setCount(res.totalCount);
    });
    return () => {
      cancelled = true;
    };
  }, [page, query, reloadKey]);

  const handleSearch = () => {
    const search = searchValue.trim();
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (search) params.set('q', search);
      else params.delete('q');
      params.delete('page');
      return params;
    });
  };

  // После бана/разбана/удаления — перезапросить текущую страницу
  const handleUpdate = () => setReloadKey((k) => k + 1);

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск пользователей..."
        createLink="/users/create"
      />

      <div className="page-table mb-3">
        {users?.length === 0 ? (
          query ? (
            <EmptyState
              icon={UsersRound}
              variant="search"
              title="Таких пользователей нет"
              description="Поиск идёт по ФИО. Проверьте, нет ли опечатки, или введите только фамилию."
            />
          ) : (
            <EmptyState
              icon={UsersRound}
              title="Пользователей пока нет"
              description="Добавьте сотрудника вручную, чтобы выдать ему доступ к админке, — остальные появятся сами после регистрации на сайте."
              action={{ label: 'Добавить пользователя', to: '/users/create', icon: UserPlus }}
            />
          )
        ) : (
          users && users.map((item) => <User onUpdate={handleUpdate} data={item} key={item.id} />)
        )}
      </div>

      <Pagination page={page} total={count} pageSize={pageSize} onPageChange={setPage} />
    </>
  );
};

export default UsersPage;
